import apiConfig from "@/config/apiConfig";
const rootPath = apiConfig.companyApi; //不带manage

//单位基本信息
export const projectUnit = {
    saveOrUpdate: rootPath + "/projectUnit/saveOrUpdate", // 新增编辑(post)
    pageList: rootPath + "/projectUnit/pageList", // 分页数据(get)
    detail: rootPath + "/projectUnit/detail", // 详情(get)
    detailByProject: rootPath + "/projectUnit/detailByProject", // 详情(get)
    remove: rootPath + "/projectUnit/remove/", // 批量删除(del)
}
//项目基本信息
export const projectBasicsInfo = {
    submit: rootPath + "/projectBasicsInfo/submit", // 提交(post)
    saveOrUpdate: rootPath + "/projectBasicsInfo/saveOrUpdate", // 新增编辑(post)
    isAllowAddData: rootPath + "/projectBasicsInfo/isAllowAddData", // 验证是否可以添加数据(post)
    getDeclareYear: rootPath + "/projectBasicsInfo/getDeclareYear", // 获取申报填报年份(post)
    pageList: rootPath + "/projectBasicsInfo/pageList", // 分页数据(get)
    detail: rootPath + "/projectBasicsInfo/detail", // 详情(get)
    remove: rootPath + "/projectBasicsInfo/remove/", // 批量删除(del)
}
//分阶段具体实施目标
export const projectImplementation = {
    updateDataList: rootPath + "/projectImplementation/updateDataList", // 批量修改(post)
    saveOrUpdate: rootPath + "/projectImplementation/saveOrUpdate", // 新增编辑(post)
    insertDataList: rootPath + "/projectImplementation/insertDataList", // 批量新增(post)
    selectList: rootPath + "/projectImplementation/selectList", // 批量查询(get)
    pageList: rootPath + "/projectImplementation/pageList", // 分页数据(get)
    detail: rootPath + "/projectImplementation/detail", // 详情(get)
    detailByProject: rootPath + "/projectImplementation/detailByProject", // 详情(get)
    remove: rootPath + "/projectImplementation/remove/", // 批量删除(del)
}
//项目规模、指标和验收内容
export const projectCheck = {
    saveOrUpdate: rootPath + "/projectCheck/saveOrUpdate", // 新增编辑(post)
    pageList: rootPath + "/projectCheck/pageList", // 分页数据(get)
    detail: rootPath + "/projectCheck/detail", // 详情(get)
    detailByProject: rootPath + "/projectCheck/detailByProject", // 详情(get)
    remove: rootPath + "/projectCheck/remove/", // 批量删除(del)
}
//预期目标
export const projectExpectations = {
    saveOrUpdate: rootPath + "/projectExpectations/saveOrUpdate", // 新增编辑(post)
    pageList: rootPath + "/projectExpectations/pageList", // 分页数据(get)
    detail: rootPath + "/projectExpectations/detail", // 详情(get)
    detailByProject: rootPath + "/projectExpectations/detailByProject", // 详情(get)
    remove: rootPath + "/projectExpectations/remove/", // 批量删除(del)
}

//获取模板
export const projectFundModel = {
    saveOrUpdate: rootPath + "/projectFundModel/saveOrUpdate", // 新增编辑(post)
    getFundModel: rootPath + "/projectFundModel/getFundModel", // 分页数据(get)
    fundDetail: rootPath + "/projectFundModel/fundDetail", // 详情(get)
    detail: rootPath + "/projectFundModel/detail", // 详情(get)
    remove: rootPath + "/projectFundModel/remove/", // 批量删除(del)
}
//申报单位项目负责人 项目负责人类型（项目负责人信息，课题负责人信息，申报单位项目负责人，合作单位项目负责人）
export const projectLeader = {
    updateDataList: rootPath + "/projectLeader/updateDataList", // 批量修改(post)
    saveOrUpdate: rootPath + "/projectLeader/saveOrUpdate", // 新增编辑(post)
    insertDataList: rootPath + "/projectLeader/insertDataList", // 批量新增(post)
    selectList: rootPath + "/projectLeader/selectList", // 批量查询(get)
    pageList: rootPath + "/projectLeader/pageList", // 分页数据(get)
    detail: rootPath + "/projectLeader/detail", // 详情(get)
    detailByProject: rootPath + "/projectLeader/detailByProject", // 详情(get)
    remove: rootPath + "/projectLeader/remove/", // 批量删除(del)
}
//研究人员
export const projectResearchers = {
    updateDataList: rootPath + "/projectResearchers/updateDataList", // 批量修改(post)
    saveOrUpdate: rootPath + "/projectResearchers/saveOrUpdate", // 新增编辑(post)
    insertDataList: rootPath + "/projectResearchers/insertDataList", // 批量新增(post)
    selectList: rootPath + "/projectResearchers/selectList", // 批量查询(get)
    pageList: rootPath + "/projectResearchers/pageList", // 分页数据(get)
    detail: rootPath + "/projectResearchers/detail", // 详情(get)
    remove: rootPath + "/projectResearchers/remove/", // 批量删除(del)
}
// 项目经费预算情况
export const projectFundRecord = {
    updateData: rootPath + "/projectFundRecord/updateData", // 新增(post)
    saveOrUpdate: rootPath + "/projectFundRecord/saveOrUpdate", // 新增(post)
    pageList: rootPath + "/projectFundRecord/pageList", // 分页数据(get)
    fundDetail: rootPath + "/projectFundRecord/fundDetail", // 项目详情(get)
    detail: rootPath + "/projectFundRecord/detail", // 详情(get)
    remove: rootPath + "/projectFundRecord/remove/", // 批量删除(del)
}


//报告正文
export const projectReporttext = {
    saveOrUpdate: rootPath + "/projectReporttext/saveOrUpdate", // 新增编辑(post)
    pageList: rootPath + "/projectReporttext/pageList", // 分页数据(get)
    detail: rootPath + "/projectReporttext/detail", // 详情(get)
    detailByProject: rootPath + "/projectReporttext/detailByProject", // 详情(get)
    remove: rootPath + "/projectReporttext/remove/", // 批量删除(del)
}
//合作单位信息
export const projectCooperative = {
    saveOrUpdate: rootPath + "/projectCooperative/saveOrUpdate", // 新增编辑(post)
    pageList: rootPath + "/projectCooperative/pageList", // 分页数据(get)
    detail: rootPath + "/projectCooperative/detail", // 详情(get)
    detailByProject: rootPath + "/projectCooperative/detailByProject", // 详情(get)
    remove: rootPath + "/projectCooperative/remove/", // 批量删除(del)
}
//重点研发计划项目扩展
export const projectImportantResearch = {
    saveOrUpdate: rootPath + "/projectImportantResearch/saveOrUpdate", // 新增编辑(post)
    pageList: rootPath + "/projectImportantResearch/pageList", // 分页数据(get)
    detail: rootPath + "/projectImportantResearch/detail", // 详情(get)
    detailByProject: rootPath + "/projectImportantResearch/detailByProject", // 详情(get)
    remove: rootPath + "/projectImportantResearch/remove/", // 批量删除(del)
}
//科技成果转化引导专项
export const projectAchievement = {
    saveOrUpdate: rootPath + "/projectAchievement/saveOrUpdate", // 新增编辑(post)
    pageList: rootPath + "/projectAchievement/pageList", // 分页数据(get)
    detail: rootPath + "/projectAchievement/detail", // 详情(get)
    detailByProject: rootPath + "/projectAchievement/detailByProject", // 详情(get)
    remove: rootPath + "/projectAchievement/remove/", // 批量删除(del)
}
// 相关附件
export const projectAnnex = {
    saveOrUpdate: rootPath + "/projectAnnex/saveOrUpdate", // 新增编辑(post)
    selectList: rootPath + "/projectAnnex/selectList", // 项目详情(get)
    pageList: rootPath + "/projectAnnex/pageList", // 分页数据(get)
    detailByProject: rootPath + "/projectAnnex/detailByProject", // 详情(get)
    detail: rootPath + "/projectAnnex/detail", // 详情(get)
    remove: rootPath + "/projectAnnex/remove/", // 批量删除(del)
}